// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { useContext } from "react";

import { Button, ButtonsWrapper, TiVoTargetsTable } from "components/elements";
import { Column, Row, Overlay, Section, Subsection } from "components/layout";
import { ROLES } from "containers/Permissions";
import { useActiveOrganization } from "hooks/utils";
import { API_URLS } from "src/config";
import { NO_VALUE_PLACEHOLDER } from "src/constants";
import { HtmlTranslation, trans } from "src/translations";

import { ManifestDataContext } from "../ManifestData";
import { getEditPath } from "../utils";
import { ManifestDetailsTable } from "./components";
import styles from "./ManifestSummary.scss";

const documentationURL = `${API_URLS.CONTENT_SUITE_API}/docs/api#/paths/~1v1~1apps~1manifests/get`;

export const ManifestSummaryTab = () => {
  const { app, loading, manifest } = useContext(ManifestDataContext);
  const { activeOrganization } = useActiveOrganization();
  const userRoles = activeOrganization?.roles ?? [];
  const isAppIntegrator = userRoles.includes(ROLES.moderator.appIntegrator);

  return (
    <Overlay active={loading} message={trans.LOADING()}>
      <Section
        className={styles.textSection}
        header={trans.APP_DETAILS_MANIFEST__DETAILS_HEADER()}
      >
        <HtmlTranslation
          transFunc={trans.APP_DETAILS_MANIFEST__DETAILS_DESCRIPTION}
          transParams={{
            url: documentationURL,
          }}
          component="p"
        />
      </Section>
      <ButtonsWrapper>
        <Button
          to={getEditPath(manifest?.id || "")}
          disabled={!isAppIntegrator}
        >
          {trans.APP_MANIFESTS_EDIT_MANIFEST()}
        </Button>
      </ButtonsWrapper>
      <Section header={trans.APP_DETAILS_MANIFEST__DETAILS_TARGET_HEADER()}>
        <Row>
          <Column>
            <Subsection
              header={
                app.name
                  ? trans.APP_DETAILS_MANIFEST__DETAILS_TARGET_APP_LABEL()
                  : trans.APP_DETAILS_MANIFEST__DETAILS_TARGET_APP_ID_LABEL()
              }
            >
              {app.name || manifest?.provider_id || NO_VALUE_PLACEHOLDER}
            </Subsection>
          </Column>
          <Column>
            <TiVoTargetsTable targets={manifest?.targets ?? {}} />
          </Column>
        </Row>
      </Section>
      <ManifestDetailsTable
        attributes={manifest?.attributes ?? {}}
        loading={loading}
      />
    </Overlay>
  );
};
